import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/styles';
import { withRouter } from 'react-router-dom';
import Page from '../../components/Page/Page';
import { NetworkContext } from '../../context/NetworkContext';
import { SnackBarContext } from '../../context/SnackbarContext';
import {
  Button,
  Card,
  CardContent,
  CardHeader,
  Grid,
  TextField,
  Typography,
} from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    maxWidth: '100%',
    padding: theme.spacing(3),
  },
}));

export const SubscriptionSettings = withRouter(() => {
  const classes = useStyles();
  const { sendNetworkRequest } = React.useContext(NetworkContext);
  const snackbarCtx = React.useContext(SnackBarContext);
  const [values, setValues] = useState({
    reminder_days_before: 7,
    grace_days_after: 7,
    default_renewal_days: 365,
  });

  async function loadSettings() {
    const result = await sendNetworkRequest('/admin/getsubscriptionsettings', {}, {}, false);
    if (result) {
      setValues({
        reminder_days_before: result.reminder_days_before,
        grace_days_after: result.grace_days_after,
        default_renewal_days: result.default_renewal_days,
      });
    }
  }

  async function saveSettings() {
    const result = await sendNetworkRequest('/admin/savesubscriptionsettings', {}, values, false);
    snackbarCtx.setSnack({
      ...snackbarCtx,
      open: true,
      type: result.status || 'success',
      msg: result.message || 'Settings saved',
      vertical: 'top',
    });
  }

  useEffect(() => {
    loadSettings();
  }, []);

  return (
    <Page className={classes.root} title="Subscription Settings">
      <Typography variant="h4" gutterBottom>Subscription Settings</Typography>
      <Card>
        <CardHeader title="Global configuration" />
        <CardContent>
          <Grid container spacing={3}>
            <Grid item xs={12} sm={4}>
              <TextField
                label="Reminder days before expiry (X)"
                type="number"
                variant="outlined"
                fullWidth
                value={values.reminder_days_before}
                onChange={e => setValues({ ...values, reminder_days_before: parseInt(e.target.value, 10) || 0 })}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField
                label="Grace days after expiry (Y)"
                type="number"
                variant="outlined"
                fullWidth
                value={values.grace_days_after}
                onChange={e => setValues({ ...values, grace_days_after: parseInt(e.target.value, 10) || 0 })}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField
                label="Default renewal days"
                type="number"
                variant="outlined"
                fullWidth
                value={values.default_renewal_days}
                onChange={e => setValues({ ...values, default_renewal_days: parseInt(e.target.value, 10) || 0 })}
              />
            </Grid>
          </Grid>
          <Button
            color="primary"
            variant="contained"
            style={{ marginTop: 24 }}
            onClick={saveSettings}
          >
            Save Settings
          </Button>
        </CardContent>
      </Card>
    </Page>
  );
});

export default SubscriptionSettings;
